import React, { useState, useEffect } from "react";
import "react-step-progress-bar/styles.css";
import { Text } from "../../vendor/roar/text";
import { CustomerService } from "../../services/CustomerService";
import { DateUtil } from "../../utils/DateUtils";
import { RadioButton } from "../../vendor/roar/radio-button";

export const CustomerViewCard = ({ customer, isSelected, onSelect }) => {
    const [membershipDetails, setMembershipDetails] = useState(null);

    useEffect(() => {
        const fetchCustomerMembershipDetails = async (abortController) => {
            const customerService = new CustomerService();
            try {
                const membershipDetails = await customerService.getMembershipByCustomerId(customer.customerId, abortController.signal)
                setMembershipDetails(membershipDetails);
            }
            catch (error) {
                console.error(error);
            }
        }

        const abortController = new AbortController();
        fetchCustomerMembershipDetails(abortController);

        return () => {
            abortController.abort();
        }
    }, [customer]);

    if (!membershipDetails) {
        return null;
    }

    const hasMembership = membershipDetails.membership !== undefined && membershipDetails.membership !== null;

    if (!hasMembership) {
        return <CustomerViewCardNotMember customer={customer} isSelected={isSelected} onSelect={onSelect} />
    }

    return (
        <div className="customer-info">
            <div
                className="member-info border"
                onClick={onSelect}
            >
                <CustomerRadioButton customer={customer} isSelected={isSelected} onSelect={onSelect} />
                <Text
                    tag="h3"
                    style={{
                        marginBottom: "0px",
                        marginTop: "25px",
                        marginLeft: "32px",
                    }}
                    variant="header3"
                >
                    {membershipDetails?.membership?.product?.name}
                </Text>

                <div className="d-flex">
                    <Text
                        style={{
                            marginTop: "0px",
                            marginRight: "20px",
                            marginLeft: "32px",
                        }}
                        variant="details"
                    >
                        Medlem siden:{" "}
                        {DateUtil.convertToDisplayFormat(
                            membershipDetails?.membership?.membershipSignUpDate
                        )}
                    </Text>
                    <CustomerMembershipExpirationWarning membership={membershipDetails.membership} />
                </div>
                <div className="d-flex">
                    <CustomerMembershipConditions membership={membershipDetails.membership} />
                </div>
            </div>
        </div>
    );
};

const CustomerMembershipExpirationWarning = ({ membership }) => {
    const validUntilDisplayString = DateUtil.convertToDisplayFormat(membership.validUntil);
    if (membership.statusText === "ExpiredMembership") {
        return (
            <CustomerMembershipExpirationWarningText key="expired" className="text-danger">
                Utløpt: {validUntilDisplayString}
            </CustomerMembershipExpirationWarningText>
        );
    }

    if (membership.statusText === "InactiveMembership") {
        return (
            <CustomerMembershipExpirationWarningText key="expired" className="">
                Gyldig til: {validUntilDisplayString}
            </CustomerMembershipExpirationWarningText>
        );
    }

    return null;
};

const CustomerMembershipConditions = ({ membership }) => {
    const conditions = [...generateMembershipConditions(membership)];

    if (conditions.length === 0) {
        return null;
    }

    return (
        <div>
            {conditions}
        </div>
    );
};

const generateMembershipConditions = function* (membership) {
    if (membership.statusText === "ActiveMembership" ) {
        const roadsideAssistance = membership?.roadSideAssistance;

        if (roadsideAssistance?.isActivationPeriod === true){
            yield (
                <CustomerMembershipExpirationWarningText key="roadside_activation" className="">
                    Veihjelp aktiv fra: {DateUtil.convertToDisplayFormat(roadsideAssistance?.activationDate)}
                </CustomerMembershipExpirationWarningText>
            );
        }
    }
};

const CustomerMembershipExpirationWarningText = ({ className, children }) => (
    <Text
        style={{
            marginTop: "0px",
            marginRight: "22px",
            marginLeft: "32px",
        }}
        variant="details"
        className={className ?? ""}
    >
        {children}
    </Text>);

const CustomerViewCardNotMember = ({ customer, isSelected, onSelect }) => {
    return (
        <div className="customer-info">
            <CustomerRadioButton customer={customer} isSelected={isSelected} onSelect={onSelect} />
        </div>
    );
}

const CustomerRadioButton = ({ customer, isSelected, onSelect }) => {
    return (<RadioButton
        label={`${customer?.basic?.firstName} ${customer?.basic?.lastName} ${customer?.address?.city ? "- " + customer?.address?.city : ""}`}
        message={customer?.customerNumber}
        name="customer"
        value={customer}
        checked={isSelected}
        onChange={onSelect}
        width="full"
        outline
        className="custom-radio-button"
    />);
}
